import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { TAB_ITEMS } from '@/features/settings/model/schemas';
import { SettingsClient } from '@/features/settings/ui/settings-client';
import { useUser } from '@/shared/providers/user-context';
import { Spinner } from '@/shared/ui';

export function SettingsPage() {
  const { user, isLoading } = useUser();

  if (isLoading || !user) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size="sm" />
      </div>
    );
  }

  // 권한에 따라 필터링된 탭 아이템
  const filteredTabItems = TAB_ITEMS.filter((item) => item.role.includes(user.role));

  return (
    <>
      <Helmet>
        <title>설정 | 동구바이오제약</title>
      </Helmet>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="sm" />
          </div>
        }
      >
        <SettingsClient
          filteredTabItems={filteredTabItems}
          user={user}
        />
      </Suspense>
    </>
  );
}
